import React from 'react';
import { roles } from '@nxsys/store/constants';

const ComingSoon = React.lazy(
  () => import('../../../modules/errorPages/ComingSoon'),
);

export const vatCodesConfig = [
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/vat-codes/:vatCodeId',
    element: <ComingSoon />,
  },
];
